import React from 'react'
import { ActionExecution } from '../../domain/ActionExecution'
import moment from 'moment/moment'
import Link from '../../helper/link'

interface Props {
    actionExecutions?: ActionExecution[]
}

interface DeliveryStatusLabel {
    label: string
    className: string
    tooltip?: string
}

const DELIVERY_STATUS_LABELS: Record<string, DeliveryStatusLabel> = {
    success: { label: 'success', className: 'label-success' },
    error: {
        label: 'error',
        className: 'label-danger',
        tooltip: 'API of this integration returned errors that prevented notifications from being delivered (ex HTTP 500)',
    },
    unauthorized: {
        label: 'unauthorized',
        className: 'label-warning',
        tooltip: 'API of this integration returned authentication/authorization errors (HTTP 401/403 codes)',
    },
    ignored: {
        label: 'ignored',
        className: 'label-default',
        tooltip: 'Delivery to this integration was ignored because notifications for this applications were muted.',
    },
    skipped: {
        label: 'skipped',
        className: 'label-default',
        tooltip: 'Delivery to this integration was skipped because notification specific pre-conditions did not match.',
    },
}

// HandlerException codes, stored as delivery status by the incident action worker
const HANDLER_EXCEPTION_STATUSES: Record<string, string> = {
    '10': 'unauthorized',
    '20': 'error',
    '21': 'error',
    '30': 'error',
    '40': 'error',
    '50': 'error',
}

export const DeliveryStatus = ({ status }: { status: string }) => {
    const normalizedStatus = HANDLER_EXCEPTION_STATUSES[String(status)] ?? String(status)
    const deliveryStatus = DELIVERY_STATUS_LABELS[normalizedStatus] ?? { label: normalizedStatus, className: 'label-default' }

    if (deliveryStatus.tooltip === undefined) {
        return <span className={`label ${deliveryStatus.className}`}>{deliveryStatus.label}</span>
    }

    return (
        <span
            className={`label ${deliveryStatus.className} tw-tooltip tw-tooltip-dataText tw-tooltip--left`}
            data-tooltip-text={deliveryStatus.tooltip}
        >
            {deliveryStatus.label}
        </span>
    )
}

export class NotificationLog extends React.Component<Props> {
    public render() {
        if (!this.props.actionExecutions || this.props.actionExecutions.length === 0) {
            return (
                <div className="box box-default" style={{ marginBottom: 0, paddingLeft: 10 }}>
                    <div className="box-body">
                        <p>No notifications have been sent for this event.</p>
                        <p>
                            To configure notifications click <Link route="XhprofAlertBundle.Configuration.list">here</Link>
                        </p>
                    </div>
                </div>
            )
        }

        return (
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.actionExecutions.map((actionExecution, index) => (
                        <tr key={index}>
                            <td>
                                {moment
                                    .utc(actionExecution.executionTime)
                                    .local()
                                    .format('DD.MM.YY HH:mm')}
                            </td>
                            <td>{actionExecution.action.readableType}</td>
                            <td>{actionExecution.action.title}</td>
                            <td>
                                <DeliveryStatus status={actionExecution.deliveryStatus} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }
}
